import React from "react"
import PropTypes from "prop-types"
import Layout from "../components/Layout"
import createCanonicalUrl from "../utils/createCanonicalUrl"
import TitleAndMetaTags from "../components/TitleAndMetaTags"
import { withStyles } from "@material-ui/core/styles"

import ProjectsPage from "../components/Projects"

const styles = {
  root: {
    width: "100%",
  },
}

const Projects = ({ location, classes }) => (
  <Layout location={location}>
    <TitleAndMetaTags
      title="Projects &ndash; DB System NUS"
      canonicalUrl={createCanonicalUrl("/projects")}
    />
    <div className={classes.root}>
      <ProjectsPage />
    </div>
  </Layout>
)

Projects.propTypes = {
  //data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Projects)
